import getEnvironmentVar from './getEnvironmentVar'

const SYNTHETICS_TO_BE_RENAMED = [
  {
    symbol: '1INCH',
    name: '1inch',
  },
  {
    symbol: 'AAVE',
    name: 'Aave',
  },
  {
    symbol: 'BTC',
    name: 'Bitcoin',
  },
  {
    symbol: 'DAI',
    name: 'Dai Stablecoin',
  },
  {
    symbol: 'ETH',
    name: 'Ether',
  },
  {
    symbol: 'LINK',
    name: 'Chainlink',
  },
  {
    symbol: 'SNX',
    name: 'Synthetix',
  },
  {
    symbol: 'UNI',
    name: 'Uniswap',
  },
  {
    symbol: 'YFI',
    name: 'yearn.finance',
  },
  {
    symbol: 'XMR',
    name: 'Monero',
  },
  {
    symbol: 'ADA',
    name: 'Cardano',
  },
  {
    symbol: 'CAKE',
    name: 'PancakeSwap',
  },
  {
    symbol: 'LTC',
    name: 'Litecoin',
  },
  {
    symbol: 'DOT',
    name: 'Polkadot',
  },
  {
    symbol: 'BNB',
    name: 'Binance Coin',
  },
  {
    symbol: 'AVAX',
    name: 'Avalanche',
  },
  {
    symbol: 'ATOM',
    name: 'Cosmos',
  },
  {
    symbol: 'DASH',
    name: 'Dash',
  },
  {
    symbol: 'BCH',
    name: 'Bitcoin Cash',
  },
  {
    symbol: 'XLM',
    name: 'Stellar',
  },
  {
    symbol: 'DOGE',
    name: 'Dogecoin',
  },
  {
    symbol: 'CRV',
    name: 'Curve DAO',
  },
  {
    symbol: 'REN',
    name: 'Ren',
  },
  {
    symbol: 'NEXO',
    name: 'Nexo',
  },
  {
    symbol: 'COMP',
    name: 'Compound',
  },
  {
    symbol: 'BNT',
    name: 'Bancor',
  },
  {
    symbol: 'LRC',
    name: 'Loopring',
  },
  {
    symbol: 'TRX',
    name: 'TRON',
  },
  {
    symbol: 'BAL',
    name: 'Balancer',
  },
  {
    symbol: 'FIL',
    name: 'Filecoin',
  },
  {
    symbol: 'MKR',
    name: 'Maker',
  },
  {
    symbol: 'RUNE',
    name: 'THORChain',
  },
  {
    symbol: 'NEO',
    name: 'Neo',
  },
  {
    symbol: 'SOL',
    name: 'Solana',
  },
  {
    symbol: 'GRT',
    name: 'The Graph',
  },
  {
    symbol: 'XTZ',
    name: 'Tezos',
  },
  {
    symbol: 'XEM',
    name: 'NEM',
  },
  {
    symbol: 'RSR',
    name: 'Reserve Rights',
  },
  {
    symbol: 'SUSHI',
    name: 'Sushi',
  },
  {
    symbol: 'LEO',
    name: 'LEO',
  },
  {
    symbol: 'VGX',
    name: 'Voyager',
  },
]

const SYNTH_ADDRESSES = {}

SYNTHETICS_TO_BE_RENAMED.forEach((synth) => {
  const key = getEnvironmentVar(synth.symbol + '_ADDRESS').toLowerCase()
  // note: on testnet, not all Tokens are defined
  if (key) {
    SYNTH_ADDRESSES[key] = synth.name + ' @ Energi'
  }
})

const getName = (token) => {
  return SYNTH_ADDRESSES[token.id.toLowerCase()] || token.name
}

export default getName
